import * as React from "react";
import {Box} from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{width: "100%", display: "block"}}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3, backgroundColor: "white"}}>
                    {children}
                </Box>
            )}
        </div>
    );
}
